import { FormAction } from "../enums";

export interface FormInput<T> {
  action: FormAction;
  item: T;
  extraData?: any
}
